<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="120px"
    />
  </div>
</template>

<script>
export default {
  name: 'Feiqiyeyonghu',
  components: {},
  data() {
    return {
      url: '/user/account/page?unit=false',
      columns: [
        {
          label: '用户所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '注册时间',
          prop: 'createTime'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '绑定标签',
          prop: 'label'
        },
        {
          label: '用户经验值',
          prop: 'accumulatePoints'
        },
        {
          label: '状态',
          prop: 'frozen',
          template: function(index, reocrd) {
            return reocrd.frozen
              ? "<div class='circle red'></div><span>冻结</span>"
              : "<div class='circle green'></div><span>正常</span>"
          }
        }
      ],
      // 操作栏
      handles: {
        width: 500,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'user.notenterprise.details',
            handle: (resp) => {
              this.$router.push({
                path: './detailIsenterprise',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '用户钱包',
            icon: 'el-icon-bank-card',
            permission: 'user.notenterprise.wallet',
            // style: "color:#00FF00",
            handle: (resp) => {
              this.$router.push({
                path: './isuserWallet',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '修改',
            permission: 'user.notenterprise.update',
            handle: (resp) => {
              this.$router.push({
                path: './reviseIsenterprise',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '密码重置',
            permission: 'user.notenterprise.Reset',
            url: '/user/account/resetPwd',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定将密码重置为888888？',
            before: (index, record) => {
              const p = {
                id: record.id
              }
              return p
            },
            handle: (resp) => {
              this.$notify({
                title: '成功',
                message: '重置密码成功',
                type: 'success'
              })
            }
          },
          {
            label: '冻结',
            permission: 'user.notenterprise.frozen',
            style: 'color:red',
            getLabel: function(record) {
              return record.frozen ? '恢复' : '冻结'
            },
            url: '/user/account/frozen',
            method: 'post',
            isConfirm: true,
            confirmText: '是否确定执行本操作？',
            before: function(index, record) {
              const p = {
                id: record.id
              }
              return p
            },
            handle: (resp, o) => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '删除',
            permission: 'user.notenterprise.delete',
            style: 'color:red',
            url: '/user/account',
            method: 'delete',
            isConfirm: true,
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'userName',
          placeholder: '请输入用户姓名'
        },
        {
          label: '归属企业',
          prop: 'orgName',
          placeholder: '请输入归属企业'
        },
        {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        },
        {
          label: '状态',
          prop: 'frozen',
          placeholder: '请选择状态',
          type: 'select',
          data: [
            {
              label: '正常',
              value: 'false'
            },
            {
              label: '冻结',
              value: 'true'
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'user.notenterprise.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addIsenterprise')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/userManagement/isenterpriseUser.vue